import PropTypes from 'prop-types'

const Select = ({ options, value, onSelect, ...props }) => {
  return (
    <div className='select'>
      <select onChange={onSelect} {...props}>
        {options.map((item, key) => (
          <option
            key={key}
            label={item.title}
            value={item.value}
            defaultValue={options ? options[0].value : ''}
            selected={item.value === value}
          >
            {item.title}
          </option>
        ))}
      </select>
    </div>
  )
}

Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onSelect: PropTypes.func,
}

export default Select
